import { messageService } from '../../Service/message-service';
import React from 'react';
import { messageStruct } from './types';
import styles from './ImportantMessage.scss';
import PropTypes from 'prop-types';

const BasicListElement = ({ children, keyInternal }) => {
  return <li key={keyInternal}>{children}</li>;
};

BasicListElement.propTypes = {
  children: PropTypes.element.isRequired,
  keyInternal: PropTypes.string.isRequired,
};

const TranslatedListElement = ({ message, keyInternal }) => {
  const label = messageService.get(
    message.descriptionId,
    ...(message.additionalAttributes || []),
  );
  return (
    <BasicListElement key={keyInternal} keyInternal={keyInternal}>
      {label}
    </BasicListElement>
  );
};

TranslatedListElement.propTypes = {
  message: messageStruct,
  keyInternal: PropTypes.string.isRequired,
};

const MessageMapper = ({ message, keyInternal }) => {
  if (message.descriptionComponent) {
    const Description = message.descriptionComponent;
    return (
      <BasicListElement key={keyInternal} keyInternal={keyInternal}>
        <Description additionalAttributes={message.additionalAttributes} />
      </BasicListElement>
    );
  }

  return (
    <TranslatedListElement
      message={message}
      key={message.descriptionId}
      keyInternal={keyInternal}
    />
  );
};

MessageMapper.propTypes = {
  message: messageStruct,
  keyInternal: PropTypes.string,
};

export const MessagesList = ({ messages }) => {
  return (
    <ul className={styles.descriptionList}>
      {messages.map((message) => (
        <MessageMapper
          message={message}
          keyInternal={message.descriptionId}
          key={message.descriptionId}
        />
      ))}
    </ul>
  );
};

MessagesList.propTypes = {
  messages: PropTypes.arrayOf(messageStruct).isRequired,
};
